import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { InvoicesComponent } from "./invoices/invoices.component";
import { InvoiceDetailsComponent } from "./invoice-details/invoice-details.component";

export const INVOICE_ROUTES: Routes = [
  {
    path: 'invoices',
    pathMatch: 'full',
    redirectTo: 'invoices/overview'

  },
  {
    path: 'invoices/overview',
    component: InvoicesComponent,
    canActivate: [authGuard]
  },
  {
    path: 'invoice/details/:praefix/:invid',
    component: InvoiceDetailsComponent,
    canActivate: [authGuard]
  }
]
